import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setTargetValue } from '../../store/slices/targetSlice';
import {
    Box,
    DialogTitle,
    DialogContent,
    TextField,
    Alert,
} from "@mui/material";


const EditTargetLimits = () => {

    const dispatch = useAppDispatch();
    const { editingTarget: target, targets } = useAppSelector(state => state.targetReducer);
    const dispatchSetValue = (field, value) => dispatch(setTargetValue({ field, value }));

    const childTargets = useMemo(() => targets.filter(t => t.rollupTargetId === target.targetId), [target.targetId, targets]);

    const missingTargets = useMemo(() => childTargets.filter(t => !t.target), [childTargets]);

    const disableChanges = useMemo(() => target.areaId === 0, [target.areaId]);

    return (
        (<React.Fragment>
            <DialogTitle>
                {target.description}
            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap="10px" pt={2}>
                    {missingTargets.length > 0 && <Alert severity="error">{missingTargets.length} out of {childTargets.length} targets are missing target value.</Alert>}
                    <TextField
                        label="Owner Email"
                        value={target.ownerEmail || ""}
                        error={!target.ownerEmail}
                        helperText={!target.ownerEmail && "required"}
                        onChange={(e) => dispatchSetValue("ownerEmail", e.target.value)}
                    />
                    <TextField
                        disabled={disableChanges}
                        type="number"
                        label="Red Lower"
                        value={target.redLower || ""}
                        onChange={(e) => dispatchSetValue("redLower", e.target.value)}
                    />
                    <TextField
                        disabled={disableChanges}
                        type="number"
                        label="Amber Lower"
                        value={target.amberLower || ""}
                        onChange={(e) => dispatchSetValue("amberLower", e.target.value)}
                    />
                    <TextField
                        disabled={disableChanges}
                        type="number"
                        label="Target"
                        value={target.target == null ? "" : target.target}
                        error={target.target !== 0 && !target.target && !disableChanges}
                        helperText={target.target !== 0 && !target.target && !disableChanges && "required"}
                        onChange={(e) => dispatchSetValue("target", e.target.value)}
                    />
                    <TextField
                        disabled={disableChanges}
                        type="number"
                        label="Amber Upper"
                        value={target.amberUpper || ""}
                        onChange={(e) => dispatchSetValue("amberUpper", e.target.value)}
                    />
                    <TextField
                        disabled={disableChanges}
                        type="number"
                        label="Red Upper"
                        value={target.redUpper || ""}
                        onChange={(e) => dispatchSetValue("redUpper", e.target.value)}
                    />
                </Box>
            </DialogContent>
        </React.Fragment>)
    );
};

export default EditTargetLimits;